var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.itemActif)?_c('StrapiEvenementComponent',{attrs:{"item":_vm.itemActif,"items":_vm.autresItems,"expand":true}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }